import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d91d9f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "name-box xag-flex-lr" }
const _hoisted_3 = { class: "name xag-ellipsis" }
const _hoisted_4 = { class: "explain" }
const _hoisted_5 = { class: "explain" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "v-line" }, "|", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "no-data-box xag-flex-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon common-icon" }),
  /*#__PURE__*/_createElementVNode("div", null, "暂无服务单")
], -1))
const _hoisted_10 = [
  _hoisted_9
]

import { List, PullRefresh } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { FaultBillItem } from '@/types/fault'
import { getRepairOrderList } from '@/apis/malfunction-repair'
import { GetMalfunctionRepairOrderListItem } from '@/types/malfunction-repair'
import { ref, Ref, toRefs, watch, onUnmounted, withDefaults } from 'vue'
import refreshPageSetup from '@/compositions/refreshPage'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-order-list-wrap',
  props: {
    billType: { default: '' }
  },
  setup(__props: any) {

const props = __props as { billType: string };


const $router = useRouter()
const $route = useRoute()
let {
  error,
  loading,
  finished,
  refreshing,
  _query,
  _ts,
  generateLoad,
  generateRefresh,
  errorDealFunc,
} = refreshPageSetup()
let { billType } = toRefs(props)
const device_type = $route.query.device_type
let items: Ref<GetMalfunctionRepairOrderListItem[]> = ref([])
let timer: number
watch(billType, (): void => {
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    _ts = Date.now()
    items.value = []
    if (finished.value) {
      _query.page = 0
      finished.value = false
    } else {
      loading.value = true
      _query.page = 1
      getItems()
    }
  })
})
const getItems = async (): Promise<void> => {
  const ts: number = _ts
  try {
    const obj = {
      status: billType.value as string,
      ..._query,
      device_type,
    }
    if (!obj.device_type) {
      delete obj.device_type
    }
    const result = await getRepairOrderList(obj)
    let list = result.data
    if (ts !== _ts) return
    if (refreshing.value) {
      items.value = []
      refreshing.value = false
    }
    list.forEach((it) => {
      switch (it.status) {
        case 'WAIT_RECEIVE':
          it.bColor = 'rgba(249,195,3,1)'
          break
        case 'HANDLE_ING':
          it.bColor = 'rgba(0,132,254,1)'
          break
        case 'END':
          it.bColor = 'rgba(0,195,120,1)'
          break
        case 'CANCEL':
          it.bColor = 'rgba(0,0,0,0.22)'
          break
        default:
          it.bColor = 'rgba(249,195,3,1)'
      }
    })
    items.value = _query.page === 1 ? list : items.value.concat(...list)
    loading.value = false
    finished.value = list.length < _query.per_page
  } catch (err: unknown) {
    if (ts !== _ts) return
    errorDealFunc(err as { message: string })
  }
}
function toBillDetail(item: GetMalfunctionRepairOrderListItem) {
  console.log('item', item)
  if (item.version === 'v2') {
    $router.push({ name: 'malfunction-repair-service-order-detail', query: { guid: item.guid } })
    return
  }
  $router.push({ name: 'servicedetail', params: { guid: item.guid } })
}
function getServiceTypeText(text: string) {
  const hasServiceText = text.indexOf('服务') !== -1
  return `${text}${hasServiceText ? '' : '服务'}`
}
const onLoad = generateLoad(getItems)
const onRefresh = generateRefresh(getItems)
onUnmounted(() => {
  if (timer) clearTimeout(timer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PullRefresh), {
    modelValue: _unref(refreshing),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : refreshing = $event)),
    onRefresh: _unref(onRefresh),
    class: "items-box"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(List), {
        loading: _unref(loading),
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : loading = $event)),
        finished: _unref(finished),
        onLoad: _unref(onLoad),
        error: _unref(error),
        "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_isRef(error) ? (error).value = $event : error = $event)),
        "error-text": "请求失败，点击重新加载",
        class: _normalizeClass({ 'xag-flex-center': !_unref(items).length && _unref(finished) })
      }, {
        finished: _withCtx(() => [
          (_unref(items).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "没有更多了"))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item.guid,
              onClick: ($event: any) => (toBillDetail(item))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(item.service_no), 1),
                _createElementVNode("div", {
                  class: "status-box",
                  style: _normalizeStyle({ 'background-color': item.bColor || 'rgba(249,195,3,1)' })
                }, _toDisplayString(item.wait_status_text || item.status_text), 5)
              ]),
              _createElementVNode("div", _hoisted_4, "SN：" + _toDisplayString(item.serial_number), 1),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(getServiceTypeText(item.service_type_text)), 1),
                _hoisted_6,
                _createTextVNode(_toDisplayString(item.eq_model_name), 1)
              ])
            ], 8, _hoisted_1))
          }), 128))
        ]),
        _: 1
      }, 8, ["loading", "finished", "onLoad", "error", "class"])
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
}
}

})